import { useGlobalState } from "./stateProvider/StateProvider";

export const Features = {
    AppCredit: 'AppCredit',
    FamilyPlans: 'FamilyPlans',
    PlateReads: 'PlateReads',
    Surveys: 'Surveys',
    Tax: 'Tax',
    TimeProducts: 'TimeProducts',
    WashClubTime: 'WashClubTime',
    PAYG: 'PAYG',
    AwardEnhancement: 'AwardEnhancement',
    NewMaxUses: 'NewMaxUses',
    PlateReadAutoAwards: 'PlateReadAutoAwards'
}

//state safe no-hooks version for use when needed in loops/map or similar
export const SiteHasFeature = (siteFeatures, requiredFeatures) => {
    return evaluateFeatureRequirement(siteFeatures, requiredFeatures);
}

//bool check if feature is enabled or not
export const HasFeature = (requiredFeatures) => {
    const { state: { features } } = useGlobalState();
    return evaluateFeatureRequirement(features, requiredFeatures);
}

// wrapper that conditionally renders children based on enabled feature flags
// <RequireFeature requiredFeatures={FeatureA}></RequireFeature> ==> requires FeatureA
// <RequireFeature requiredFeatures={[FeatureA,FeatureB]}></RequireFeature> ==> requires either FeatureA or FeatureB
// <RequireFeature requiredFeatures={{all: [FeatureA], any: [FeatureB, FeatureC]}}><RequireFeature> ==> requires FeatureA AND either FeatureB or FeatureC
const RequireFeature = ({ requiredFeatures, children }) => {
    const { state: { features } } = useGlobalState();
    return evaluateFeatureRequirement(features, requiredFeatures)
        ? children
        : null;
}

export default RequireFeature;

// Supports: string or array (OR logic), or an object { all:[], any:[] } for more complex AND/OR conditions.
// Empty/undefined requirement allows by default; invalid types fail.
// Returns true only if all `all` features match AND at least one `any` feature matches.
const evaluateFeatureRequirement = (siteFeatures, require) => {
    siteFeatures = Array.isArray(siteFeatures) ? siteFeatures : [];

    // No requirement → allow
    if (!require) return true;

    let all = [];
    let any = [];

    if (Array.isArray(require)) {
        // Legacy shorthand: OR logic
        any = require;
    } 
    else if (typeof require === 'string') {
        // Legacy shorthand: single feature OR
        any = [require];
    }
    else if (typeof require === 'object') {
        const hasAll = Array.isArray(require.all);
        const hasAny = Array.isArray(require.any);

        if (!hasAll && !hasAny) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn("RequireFeature: object missing 'all' or 'any' keys:", require);
            }
            return false;
        }

        all = hasAll ? require.all : [];
        any = hasAny ? require.any : [];
    }
    else {
        if (process.env.NODE_ENV !== 'production') {
            console.warn("RequireFeature: invalid requirement type:", require);
        }
        return false;
    }

    // Clean out falsy values
    all = all.filter(Boolean);
    any = any.filter(Boolean);

    const has = f => siteFeatures.includes(f);

    const allOk = all.length === 0 || all.every(has);
    const anyOk = any.length === 0 || any.some(has);

    return allOk && anyOk;
}

